<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Kullanıcı Tenant Yönetimi</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field v-model="search" append-icon="search" label="Ara" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="showAddDialog" class="mb-2">
        <v-icon left>add</v-icon>
        Yeni UserTenant Ekle
      </v-btn>
    </v-toolbar>
    
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="userTenants"
      :search="search"
      :rows-per-page-items="pageItems"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ getUserName(props.item.userId) }}</td>
        <td class="text-xs-center">{{ getTenantName(props.item.tenantId) }}</td>
        <td class="text-xs-center">{{ getMarketPlaceName(props.item.mpId) }}</td>
        <td class="text-xs-center">
          <v-icon small class="mr-2" @click="editUserTenant(props.item)" color="blue">edit</v-icon>
          <v-icon small @click="deleteUserTenant(props.item)" color="red">delete</v-icon>
        </td>
      </template>
    </v-data-table>

    <!-- UserTenant Ekleme/Düzenleme Dialog -->
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedIndex === -1 ? 'Yeni UserTenant' : 'UserTenant Düzenle' }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  v-model="editedItem.userId"
                  :items="users"
                  item-text="displayName"
                  item-value="id"
                  label="Kullanıcı"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="editedItem.tenantId"
                  :items="tenantOptions"
                  item-text="name"
                  item-value="id"
                  label="Tenant"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="editedItem.mpId"
                  :items="marketPlaceOptions"
                  item-text="name"
                  item-value="id"
                  label="MarketPlace"
                  required
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">İptal</v-btn>
          <v-btn color="blue darken-1" text @click="saveUserTenant" :loading="saving">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Silme Onay Dialog -->
    <v-dialog v-model="deleteDialog" max-width="350px">
      <v-card>
        <v-card-title class="headline">UserTenant'ı Sil</v-card-title>
        <v-card-text>Bu UserTenant'ı silmek istediğinizden emin misiniz?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">İptal</v-btn>
          <v-btn color="red darken-1" text @click="confirmDelete" :loading="deleting">Sil</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userTenants: [],
      users: [],
      loading: false,
      saving: false,
      deleting: false,
      search: '',
      dialog: false,
      deleteDialog: false,
      editedIndex: -1,
      editedItem: {
        userId: null,
        tenantId: null,
        mpId: null
      },
      defaultItem: {
        userId: null,
        tenantId: null,
        mpId: null
      },
      userTenantToDelete: null,
      pagination: {
        sortBy: 'id'
      },
      pageItems: [
        10,
        25,
        50,
        { text: 'Tümü', value: -1 }
      ],
      tenantOptions: [
        { id: 1, name: 'AltındaFirsat' },
        { id: 2, name: 'EAltin' }
      ],
      marketPlaceOptions: [],
      headers: [
        { text: 'ID', value: 'id', align: 'center' },
        { text: 'Kullanıcı', value: 'userId', align: 'center' },
        { text: 'Tenant', value: 'tenantId', align: 'center' },
        { text: 'MarketPlace', value: 'mpId', align: 'center' },
        { text: 'İşlemler', value: 'actions', sortable: false, align: 'center' }
      ]
    };
  },
  created() {
    this.loadUserTenants();
    this.loadUsers();
    this.loadMarketplaces();
  },
  methods: {
    async loadUserTenants() {
      this.loading = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/api/usertenants`, {
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
          }
        });
        this.userTenants = await response.json();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('UserTenants yüklenirken hata:', error);
        this.$store.commit('SET_MESSAGE', 'UserTenants yüklenirken hata oluştu');
        this.$store.commit('SET_DIALOG', true);
      } finally {
        this.loading = false;
      }
    },
    async loadUsers() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/api/users`, {
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
          }
        });
        const users = await response.json();
        this.users = users.map(user => ({
          ...user,
          displayName: `${user.firstName} ${user.lastName} (${user.username})`
        }));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Kullanıcılar yüklenirken hata:', error);
      }
    },
    getUserName(userId) {
      const user = this.users.find(u => u.id === userId);
      return user ? `${user.username}` : 'Bilinmeyen';
    },
    getTenantName(tenantId) {
      const tenant = this.tenantOptions.find(t => t.id === tenantId);
      return tenant ? tenant.name : 'Bilinmeyen';
    },
    getMarketPlaceName(mpId) {
      const mp = this.marketPlaceOptions.find(m => m.id === mpId);
      return mp ? mp.name : 'Bilinmeyen';
    },
    showAddDialog() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = true;
    },
    editUserTenant(userTenant) {
      this.editedIndex = this.userTenants.indexOf(userTenant);
      this.editedItem = Object.assign({}, userTenant);
      this.dialog = true;
    },
    deleteUserTenant(userTenant) {
      this.userTenantToDelete = userTenant;
      this.deleteDialog = true;
    },
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async saveUserTenant() {
      this.saving = true;
      try {
        const userTenantData = { ...this.editedItem };
        
        if (this.editedIndex > -1) {
          await fetch(`${process.env.VUE_APP_API}/api/usertenants/${userTenantData.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
            },
            body: JSON.stringify(userTenantData)
          });
          
          Object.assign(this.userTenants[this.editedIndex], userTenantData);
        } else {

          const response = await fetch(`${process.env.VUE_APP_API}/api/usertenants`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
            },
            body: JSON.stringify(userTenantData)
          });
          
          if (response.ok) {
            this.loadUserTenants(); // Listeyi yenile
          }
        }
        
        this.closeDialog();
        this.$store.commit('SET_MESSAGE', 'UserTenant başarıyla kaydedildi');
        this.$store.commit('SET_DIALOG', true);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('UserTenant kaydedilirken hata:', error);
        this.$store.commit('SET_MESSAGE', 'UserTenant kaydedilirken hata oluştu');
        this.$store.commit('SET_DIALOG', true);
      } finally {
        this.saving = false;
      }
    },
    async loadMarketplaces() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/api/users/marketplaces`, {
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
          }
        });
        this.marketPlaceOptions = await response.json();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Marketplaces yüklenirken hata:', error);
        this.marketPlaceOptions = [
          { id: 1, name: 'Hepsiburada' },
          { id: 2, name: 'Alışgidiş' },
          { id: 3, name: 'Trendyol' },
          { id: 4, name: 'Idefix' }
        ];
      }
    },
    async confirmDelete() {
      this.deleting = true;
      try {
        await fetch(`${process.env.VUE_APP_API}/api/usertenants/${this.userTenantToDelete.id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
          }
        });
        
        const index = this.userTenants.indexOf(this.userTenantToDelete);
        this.userTenants.splice(index, 1);
        
        this.deleteDialog = false;
        this.$store.commit('SET_MESSAGE', 'UserTenant başarıyla silindi');
        this.$store.commit('SET_DIALOG', true);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('UserTenant silinirken hata:', error);
        this.$store.commit('SET_MESSAGE', 'UserTenant silinirken hata oluştu');
        this.$store.commit('SET_DIALOG', true);
      } finally {
        this.deleting = false;
      }
    }
  }
};
</script>

<style scoped>
.v-toolbar {
  margin-bottom: 20px;
}
</style>
